import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { popupCurtainClass, sidePanelPopupClass, popupHeaderClass, closeButtonClass, popupContentClass } from './SidePanelPopup.styles';

export enum SidePanelModulEnum {
    NONE = -1,
    About = 0,
    AppsMenu = 1,
}

type Props = {
    visibleModule: SidePanelModulEnum;
    onClose: () => void;
    title?: string;
    children: React.ReactNode;
};

const SidePanelPopup: React.FC<Props> = ({ visibleModule, onClose, title, children }) => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const checkIfClickedOutside = (event: MouseEvent) => {
            if (visibleModule > SidePanelModulEnum.NONE && ref.current && !ref.current.contains(event.target as Node)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', checkIfClickedOutside);

        return () => {
            document.removeEventListener('mousedown', checkIfClickedOutside);
        };
    }, [visibleModule, onClose]);

    if (visibleModule === SidePanelModulEnum.NONE) {
        return null;
    }

    return (
        <>
            <div className={popupCurtainClass} />
            <div className={sidePanelPopupClass} ref={ref}>
                {title && (
                    <div className={popupHeaderClass}>
                        <h2>{title}</h2>
                        <button className={closeButtonClass} onClick={onClose} title="Close">
                            <FontAwesomeIcon icon="times" />
                        </button>
                    </div>
                )}
                <div className={popupContentClass}>{children}</div>
            </div>
        </>
    );
};

export default SidePanelPopup;
